const checkIfArrayContainsObject = (array, object) => {
  for (let i = 0; i < array.length; i++) {
    if (array[i].id === object.id) return true;
  }

  return false;
};

export default checkIfArrayContainsObject;
